import { Badge } from 'components/ui';
import { useTranslation } from 'hooks/useTranslation';
import { KbWebSourceStatus } from 'types/knowledgeBase';

interface WebSourceStatusBadgeProps {
  status: KbWebSourceStatus;
}

const WebSourceStatusBadge = ({ status }: WebSourceStatusBadgeProps) => {
  const { t } = useTranslation();

  const getColorPalette = () => {
    switch (status) {
      case KbWebSourceStatus.Active:
        return 'green';
      case KbWebSourceStatus.Syncing:
        return 'yellow';
      case KbWebSourceStatus.Pending:
        return 'blue';
      case KbWebSourceStatus.Failed:
        return 'red';
      case KbWebSourceStatus.Deleted:
        return 'gray';
      default:
        return 'gray';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case KbWebSourceStatus.Active:
        return t('app.knowledgeBase.webSources.status.active');
      case KbWebSourceStatus.Syncing:
        return t('app.knowledgeBase.webSources.status.syncing');
      case KbWebSourceStatus.Pending:
        return t('app.knowledgeBase.webSources.status.pending');
      case KbWebSourceStatus.Failed:
        return t('app.knowledgeBase.webSources.status.failed');
      case KbWebSourceStatus.Deleted:
        return t('app.knowledgeBase.webSources.status.deleted');
      default:
        return status;
    }
  };

  return (
    <Badge colorPalette={getColorPalette()}>
      {getStatusText()}
    </Badge>
  );
};

export default WebSourceStatusBadge;
